import type React from "react";

type ProgramHighlight = {
  title: string;
  summary: string;
};

type ProgramsCarouselProps = {
  id?: string;
  programs: ProgramHighlight[];
};

const ProgramsCarousel: React.FC<ProgramsCarouselProps> = ({
  id,
  programs,
}) => {
  const hasPrograms = programs.length > 0;

  return (
    <section id={id} className="py-16">
      <div className="container space-y-10">
        <div className="max-w-2xl">
          <h2 className="text-3xl font-semibold text-primary-900">
            Program highlights
          </h2>
          <p className="mt-2 text-base text-primary-800/80">
            These focus areas reflect the compassionate service, education, and
            sustainable development efforts at the heart of our mission.
          </p>
        </div>

        {hasPrograms ? (
          <div className="grid gap-6 md:grid-cols-3">
            {programs.map((program) => (
              <article
                key={program.title}
                className="flex flex-col gap-4 p-6 bg-white border shadow-sm rounded-2xl border-primary-200"
              >
                <h3 className="text-lg font-semibold text-primary-800">
                  {program.title}
                </h3>
                <p className="text-sm text-primary-700/80">{program.summary}</p>
              </article>
            ))}
          </div>
        ) : (
          <article className="flex flex-col gap-4 p-6 bg-white border shadow-sm rounded-2xl border-primary-200">
            <h3 className="text-lg font-semibold text-primary-800">
              Program details coming soon
            </h3>
            <p className="text-sm text-primary-700/80">
              We&apos;re building the infrastructure that supports our mission.
              Updates will be shared as milestones are reached.
            </p>
          </article>
        )}
      </div>
    </section>
  );
};

export default ProgramsCarousel;
